import React, { useState, useEffect } from 'react';
import api from '../BaseURL/BaseURL';
import { useAuth } from '../Contexts/AuthContext';
import deleteIcon from '../../assets/Images/delete.png'; 
import editIcon from '../../assets/Images/edit.png';

const AddFoodType = () => {
  const [meals, setMeals] = useState([]);
  const [mealName, setMealName] = useState('');
  const [mealPrice, setMealPrice] = useState('');
  const [mealDescription, setMealDescription] = useState('');
  const [editingIndex, setEditingIndex] = useState(null);
  const [editMealName, setEditMealName] = useState('');
  const [editMealPrice, setEditMealPrice] = useState('');
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [descriptionIndex, setDescriptionIndex] = useState(null);
  const [editMealDescription, setEditMealDescription] = useState('');
  const [showDescriptions, setShowDescriptions] = useState(false);
  const [foodDescriptions, setFoodDescriptions] = useState([]);  
  const [currentMealName, setCurrentMealName] = useState('');
  const [deleteDescriptionData, setDeleteDescriptionData] = useState(null);
  const { token } = useAuth();
  const [errorMessage, setErrorMessage] = useState('');
  const [errorMessageDescription, setErrorMessageDescription] = useState('');
  const [successMessage, setSuccessMessage] = useState('');


    // Fetch meal types on component mount
    const fetchMeals = async () => {
      try {
        const response = await api.get('/institution/food-types', {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`, // Authorization header
          },
        });
  
        if (response.status === 200 && response.data.status) {
          const mealTypes = response.data.data.map((meal) => ({
            id: meal.id, // Include the ID from the API response
            name: meal.name,
            price: meal.price,
            show: meal.is_visible === 1, // Convert is_visible to boolean
          }));

          setMeals(mealTypes);

          if (mealTypes.length > 0) {
            const firstMealId = mealTypes[0].id;
            setCurrentMealName(mealTypes[0].name);
            await fetchFoodDescriptions(firstMealId);
            setShowDescriptions(true); // Ensure the description table is displayed
          }
        }
      } catch (error) {
        console.error('Error fetching meal types:', error);
        setErrorMessage('حدث خطأ أثناء جلب قائمة نوع الغذاء.');
      }
    };

    useEffect(() => {
    fetchMeals();
  }, [token]);

  // const addFoodType = () => {
  //   if (mealName.trim() !== '') {
  //     setMeals([...meals, { name: mealName, description: '', show: true }]);
  //     setMealName('');
  //   }
  // };

  const addFoodType = async () => {
    if (mealName.trim() === '' || mealPrice.trim() === '') {
      setErrorMessage('نوع الغذاء والسعر مطلوبان');
      setTimeout(() => setErrorMessage(''), 3000);
      return;
    }
  
    try {
      setErrorMessage(''); // Clear previous errors
  
      // Clear the input field immediately
      setMealName('');
  
      // API call to create a meal
      const response = await api.post(
        '/institution/food-types',
        { 
          name: mealName, 
          price: mealPrice, // Include the price in the API request
          is_visible: '1' 
        },
        {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`, // Authorization header
          },
        }
      );
  
      if ((response.status === 200 || response.status === 201) && response.data.status) {

        // Fetch the updated list of meals
        fetchMeals();
  
        // Show success message
        setSuccessMessage('تمت إضافة نوع الغذاء والسعر بنجاح');
        setTimeout(() => setSuccessMessage(''), 3000); // Clear success message after 3 seconds
      }
    } catch (error) {
      console.error('Error adding meal:', error);
      setErrorMessage('حدث خطأ أثناء إضافة نوع الغذاء والسعر مطلوبان. يرجى المحاولة لاحقًا.');
    }
  };

  

  // const toggleShow = (index) => {
  //   const updatedMeals = meals.map((meal, i) =>
  //     i === index ? { ...meal, show: !meal.show } : meal
  //   );
  //   setMeals(updatedMeals);
  // };

  const deleteMeal = async (index) => {
    const mealToDelete = meals[index]; // Get the meal to delete
  
    try {
      const response = await api.delete(
        `/institution/food-types/${mealToDelete.id}`, // API endpoint with meal ID
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: `Bearer ${token}`, // Authorization header
          },
        }
      );
  
      if (response.status === 200 && response.data.status) {
        // Update the meals list in the state by removing the deleted meal
        const updatedMeals = meals.filter((_, i) => i !== index);
        setMeals(updatedMeals);
  
        setSuccessMessage('تم حذف نوع الغذاء والسعر بنجاح'); // Show success message
        setTimeout(() => setSuccessMessage(''), 3000); // Clear message after 3 seconds
      }
    } catch (error) {
      console.error('Error deleting food type:', error);
      setErrorMessage('حدث خطأ أثناء حذف نوع الغذاء والسعر. يرجى المحاولة لاحقًا.');
      setTimeout(() => setErrorMessage(''), 3000); // Clear error message after 3 seconds
    } finally {
      // Clear the delete confirmation
      setDeleteIndex(null);
    }
  };
  

  const confirmDelete = (index) => {
    setDeleteIndex(index);
  };

  const cancelDelete = () => {
    setDeleteIndex(null);
  };

  const startEditing = (index) => {
    setEditingIndex(index);
    setEditMealName(meals[index].name);
    setEditMealPrice(meals[index].price || ''); // Initialize with current price
  };
  

  const saveEdit = async (index) => {
    const mealToUpdate = meals[index]; // Get the meal being edited
    const updatedData = {
      name: editMealName,
      price: editMealPrice, // Use the updated price from the input
    };
  
    try {
      const response = await api.put(
        `/institution/food-types/${mealToUpdate.id}`, // API endpoint with meal ID
        new URLSearchParams(updatedData), // Convert body to x-www-form-urlencoded
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: `Bearer ${token}`, // Authorization header
          },
        }
      );
  
      if (response.status === 200 && response.data.status) {
        // Update the meal list in the state with the new data
        const updatedMeals = meals.map((meal, i) =>
          i === index
            ? { ...meal, name: response.data.data.name, price: response.data.data.price }
            : meal
        );
  
        setMeals(updatedMeals); // Update state
        setSuccessMessage('تم تعديل نوع الغذاء والسعر بنجاح'); // Show success message
        setTimeout(() => setSuccessMessage(''), 3000); // Clear message after 3 seconds
      }
    } catch (error) {
      console.error('Error updating food type:', error);
      setErrorMessage('حدث خطأ أثناء تعديل نوع الغذاء والسعر. يرجى المحاولة لاحقًا.');
      setTimeout(() => setErrorMessage(''), 3000); // Clear error message after 3 seconds
    } finally {
      // Clear the edit mode
      setEditingIndex(null);
      setEditMealName('');
      setEditMealPrice(''); // Reset price
    }
  };
  
  

  const cancelEdit = () => {
    setEditingIndex(null);
    setEditMealName('');
    setEditMealPrice(''); // Reset price
  };
  

  const fetchFoodDescriptions = async (mealId) => {
    try {
      const response = await api.get(`/institution/food-types/${mealId}/food-descriptions`, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`, // Authorization header
        },
      });
  
      if (response.status === 200 && response.data.status) {
        // Update the state with the fetched descriptions
        setFoodDescriptions(response.data.data);
        
      }
    } catch (error) {
      console.error('Error fetching food descriptions:', error);
      setErrorMessage('حدث خطأ أثناء جلب وصف الغذاء والسعر. يرجى المحاولة لاحقًا.');
      setTimeout(() => setErrorMessage(''), 3000); // Clear error message after 3 seconds
    }
  };
  
  const addDescription = async () => {
    console.log('Meal Description:', mealDescription);
    
    if (mealDescription.trim() === '') {
      setErrorMessageDescription('وصف الغذاء مطلوب');
      setTimeout(() => setErrorMessageDescription(''), 3000);
      return;
    }
  
    // ✅ Get the meal ID based on the current selected meal
    const meal = meals.find(m => m.name === currentMealName);
    if (!meal) {
      setErrorMessage('لم يتم تحديد نوع الغذاء.');
      return;
    }
  
    const mealId = meal.id;
    console.log('Selected Meal ID:', mealId);
  
    try {
      setErrorMessage('');
  
      const response = await api.post(
        `/institution/food-types/${mealId}/food-descriptions`,
        { name: mealDescription },
        {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      console.log('API Response:', response.data);
  
      if ((response.status === 200 || response.status === 201) && response.data.status) {
        setFoodDescriptions((prevDescriptions) => [
          ...prevDescriptions,
          response.data.data,
        ]);
  
        setSuccessMessage('تمت إضافة وصف الغذاء بنجاح');
        setTimeout(() => setSuccessMessage(''), 3000);
        setMealDescription('');
      } else {
        setErrorMessage('لم يتم إضافة وصف الغذاء. يرجى المحاولة لاحقًا.');
      }
    } catch (error) {
      console.error('Error adding food description:', error?.response?.data || error.message);
      setErrorMessage('حدث خطأ أثناء إضافة وصف الغذاء. يرجى المحاولة لاحقًا.');
      setTimeout(() => setErrorMessage(''), 3000);
    }
  };
  
  
  
  
  const startDescription = async (index) => {
    console.log('startDescription called with index:', index);
    
    if (index < 0 || index >= meals.length) {
      console.error('Invalid index:', index);
      setErrorMessage('حدث خطأ: لم يتم العثور على وصف الغذاء.');
      return;
    }
  
    const meal = meals[index]; // Get the selected meal
    if (!meal || !meal.id) {
      console.error('Meal not found or has no ID:', meal);
      setErrorMessage('حدث خطأ: وصف الغذاء غير صالح.');
      return;
    }
  
    console.log('Selected Meal:', meal);
  
    setDescriptionIndex(null); // Set the description index
    setCurrentMealName(meal.name); // Update the selected meal name
    setEditMealDescription(''); // Clear any existing input
    setShowDescriptions(true); // Ensure the description table is displayed
  
    try {
      console.log('Fetching descriptions for meal ID:', meal.id);
      await fetchFoodDescriptions(meal.id); // Fetch descriptions
    } catch (error) {
      console.error('Error fetching food descriptions:', error);
      setErrorMessage('حدث خطأ أثناء جلب وصف الغذاء.');
    }
  };
  
  
  
  
  const updateDescription = async (descriptionId, mealId) => {
    if (editMealDescription.trim() === '') {
      setErrorMessage('وصف السعر مطلوب');
      return;
    }
  
    try {
      setErrorMessage(''); // Clear previous errors
  
      // API call to update the food description
      const response = await api.put(
        `/institution/food-types/${mealId}/food-descriptions/${descriptionId}`,
        new URLSearchParams({ name: editMealDescription }), // API request body
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: `Bearer ${token}`, // Authorization header
          },
        }
      );
  
      if (response.status === 200 && response.data.status) {
        // Update the foodDescriptions state with the updated description
        setFoodDescriptions((prevDescriptions) =>
          prevDescriptions.map((desc) =>
            desc.id === descriptionId
              ? { ...desc, name: response.data.data.name }
              : desc
          )
        );
  
        // Show success message
        setSuccessMessage('تم تعديل وصف الغذاء بنجاح');
        setTimeout(() => setSuccessMessage(''), 3000); // Clear message after 3 seconds
  
        // Clear editing state
        setDescriptionIndex(null);
        setEditMealDescription('');
      }
    } catch (error) {
      console.error('Error updating food description:', error);
      setErrorMessage('حدث خطأ أثناء تعديل وصف الغذاء. يرجى المحاولة لاحقًا.');
      setTimeout(() => setErrorMessage(''), 3000); // Clear error message after 3 seconds
    }
  };
  
  
  

  const saveDescription = (index) => {
    const updatedMeals = meals.map((meal, i) =>
      i === index ? { ...meal, description: editMealDescription } : meal
    );
    setMeals(updatedMeals);
    setDescriptionIndex(null);
    setEditMealDescription('');
    setShowDescriptions(true); // Switch to the description table view
  };
  const deleteDescription = async (descriptionId, mealId) => {
    if (!descriptionId || !mealId) {
      setErrorMessage('حدث خطأ: لا يمكن تحديد وصف الغذاء.');
      return;
    }
  
    try {
      const response = await api.delete(
        `/institution/food-types/${mealId}/food-descriptions/${descriptionId}`,
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      if (response.status === 200 && response.data.status) {
        // Update the state by removing the deleted description
        setFoodDescriptions((prevDescriptions) =>
          prevDescriptions.filter((desc) => desc.id !== descriptionId)
        );
  
        setSuccessMessage('تم حذف وصف الغذاء بنجاح');
        setTimeout(() => setSuccessMessage(''), 3000);
      }
    } catch (error) {
      console.error('Error deleting food description:', error);
      setErrorMessage('حدث خطأ أثناء حذف ووصف الغذاء. يرجى المحاولة لاحقًا.');
      setTimeout(() => setErrorMessage(''), 3000);
    }
  };
  

  
  const cancelDescription = () => {
    setDescriptionIndex(null);
    setEditMealDescription('');
  };

  return (
    <>
    <div className="p-6" dir="rtl">
      <h1 className="text-2xl font-semibold text-gray-700 mb-4">نوع الغذاء</h1>
      <div className="flex items-center gap-4 mb-6">
  <input
    type="text"
    value={mealName}
    onChange={(e) => setMealName(e.target.value)}
    placeholder="ادخل نوع الغذاء"
    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
  />
  <input
    type="number"
    value={mealPrice}
    onChange={(e) => setMealPrice(e.target.value)}
    placeholder="ادخل السعر"
    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
  />
  <button
    onClick={addFoodType}
    className="bg-[#DD5B35] text-white py-2 px-6 rounded-lg focus:outline-none"
  >
    إضافة
  </button>
</div>
{successMessage && (
        <p className="text-green-500 mb-4">{successMessage}</p>
      )}
      {errorMessage && (
        <p className="text-red-500 mb-4">{errorMessage}</p>
      )}

      <div className="w-full  overflow-y-auto" style={{ height: '200px' }}>
  {/* Main Table */}
  <table className="w-full border-collapse border border-gray-300 text-sm mb-6">
    <thead>
      <tr className="bg-gray-100">
        <th className="border border-gray-300 px-4 py-2 text-right">نوع الغذاء</th>
        <th className="border border-gray-300 px-4 py-2 text-right">السعر</th>
        {/* <th className="border border-gray-300 px-4 py-2 text-right">عرض / إخفاء</th> */}
        <th className="border border-gray-300 px-4 py-2 text-right">وصف الغذاء</th>
        <th className="border border-gray-300 px-4 py-2 text-right">الإجراء</th>
      </tr>
    </thead>
    <tbody>
      {meals.map((meal, index) => (
        <React.Fragment key={index}>
          <tr className="hover:bg-gray-100">
          {/* For meal.name */}
<td className="border border-gray-300 px-4 py-2 text-right">
  {editingIndex === index ? (
    <input
      type="text"
      value={editMealName}
      onChange={(e) => setEditMealName(e.target.value)}
      placeholder="اسم الوجبة"
      className="w-full px-2 py-1 border border-gray-300 rounded-lg focus:outline-none"
    />
  ) : (
    meal.name
  )}
</td>

{/* For meal.price */}
<td className="border border-gray-300 px-4 py-2 text-right">
  {editingIndex === index ? (
    <input
      type="number"
      value={editMealPrice}
      onChange={(e) => setEditMealPrice(e.target.value)}
      placeholder="السعر"
      className="w-full px-2 py-1 border border-gray-300 rounded-lg focus:outline-none"
    />
  ) : (
    meal.price || 'غير محدد'
  )}
</td>

            
            {/* <td className="border border-gray-300 px-4 py-2 text-center">
              <button
                onClick={() => toggleShow(index)}
                className={`py-1 px-3 rounded-lg ${
                  meal.show ? 'bg-green-500 text-white' : 'bg-gray-500 text-white'
                }`}
              >
                {meal.show ? 'عرض' : 'إخفاء'}
              </button>
            </td> */}
            <td className="border border-gray-300 px-4 py-2 text-center">
              <button
                onClick={() => startDescription(index)}
                className="bg-[#DD5B35] text-white py-2 px-6 rounded-lg focus:outline-none"
              >
                عرض الوصف
              </button>
            </td>
            <td className="border border-gray-300 px-4 py-2 text-center flex items-center justify-center gap-2">
            {editingIndex === index ? (
              <>
                {/* Save Button */}
                <button
                  onClick={() => saveEdit(index)}
                  className="bg-green-500 text-white p-2 rounded-lg hover:bg-green-600"
                >
                  حفظ
                </button>
                {/* Cancel Button */}
                <button
                  onClick={cancelEdit}
                  className="bg-gray-500 text-white p-2 rounded-lg hover:bg-gray-600"
                >
                  إلغاء
                </button>
              </>
            ) : (
              <>
                {/* Edit Button */}
                <button
                  onClick={() => startEditing(index)}
                  className="p-2 rounded-lg hover:bg-blue-100"
                >
                  <img src={editIcon} alt="تعديل" className="w-5 h-5" />
                </button>
                {/* Delete Button */}
                <button
                    onClick={() => confirmDelete(index)}
                    className="p-2 rounded-lg hover:bg-red-100"
                  >
                    <img src={deleteIcon} alt="حذف" className="w-5 h-5" />
                  </button>
              </>
            )}
          </td>
          </tr>
      
        </React.Fragment>
      ))}
      {meals.length === 0 && (
        <tr>
          <td colSpan="4" className="border border-gray-300 px-4 py-2 text-center text-gray-500">
            لا توجد بيانات.
          </td>
        </tr>
      )}
    </tbody>
  </table>


</div>
</div>
<div className="p-6" dir="rtl">
  <h1 className="text-2xl font-semibold text-gray-700 mb-4">  وصف الغذاء {currentMealName ? `- ${currentMealName}` : ''}</h1>
  <div className="mb-4 flex items-center gap-4">
  <input
    type="text"
    value={mealDescription}
    onChange={(e) => setMealDescription(e.target.value)}
    placeholder="ادخل وصف الغذاء"
    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
  />
  <button
    onClick={() => addDescription()}
    className="bg-[#DD5B35] text-white py-2 px-6 rounded-lg focus:outline-none"
  >
    إضافة
  </button>
</div>
{successMessage && (
        <p className="text-green-500 mb-4">{successMessage}</p>
      )}
      {errorMessageDescription && (
        <p className="text-red-500 mb-4">{errorMessageDescription}</p>
      )}
<div className="w-full overflow-y-auto" style={{ height: '200px' }}>
  {/* Description Table */}
  {showDescriptions && (
    <table className="w-full border-collapse border border-gray-300 text-sm">
      <thead>
        <tr className="bg-gray-100">
          <th className="border border-gray-300 px-4 py-2 text-right">وصف الغذاء</th>
          <th className="border border-gray-300 px-4 py-2 text-right">الإجراء</th>
        </tr>
      </thead>
      <tbody>
        {foodDescriptions.map((description, index) => (
          <React.Fragment key={description.id}>
            <tr className="hover:bg-gray-100">
              {/* Show input or description based on editing state */}
              <td className="border border-gray-300 px-4 py-2 text-right">
                {descriptionIndex === index ? (
                  <input
                    type="text"
                    value={editMealDescription}
                    onChange={(e) => setEditMealDescription(e.target.value)}
                    placeholder="ادخل وصف الغذاء"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none"
                  />
                ) : (
                  description.name
                )}
              </td>
              <td className="border border-gray-300 px-4 py-2 text-center">
                {descriptionIndex === index ? (
                  // Show Save/Cancel buttons when editing
                  <div className="flex items-center gap-4">
                    <button
                      onClick={() =>
                        updateDescription(description.id, meals[descriptionIndex].id)
                      }
                      className="bg-green-500 text-white py-2 px-6 rounded-lg hover:bg-green-600"
                    >
                      حفظ
                    </button>
                    <button
                      onClick={() => {
                        setDescriptionIndex(null); // Exit editing mode
                        setEditMealDescription(''); // Clear input
                      }}
                      className="bg-gray-500 text-white py-2 px-6 rounded-lg hover:bg-gray-600"
                    >
                      إلغاء
                    </button>
                  </div>
                ) : (
                  // Show Edit button when not editing
                  <>
                  <button
                    onClick={() => {
                      setDescriptionIndex(index); // Set editing index
                      setEditMealDescription(description.name); // Pre-fill input
                    }}
                    className="p-2 rounded-lg hover:bg-blue-100"
                  >
                    <img src={editIcon} alt="تعديل" className="w-5 h-5" />
                  </button>
                  <button
                     onClick={() =>
                      setDeleteDescriptionData({
                        descriptionId: description.id,
                        mealId: meals.find((meal) => meal.id === description.food_type_id)?.id,
                      })
                    }
                    className="p-2 rounded-lg hover:bg-red-100"
                  >
                    <img src={deleteIcon} alt="حذف" className="w-5 h-5" />
                  </button>

                 </>
                )}
              </td>
            </tr>
          </React.Fragment>
        ))}
        {foodDescriptions.length === 0 && (
          <tr>
            <td
              colSpan="2"
              className="border border-gray-300 px-4 py-2 text-center text-gray-500"
            >
              لا توجد أوصاف متاحة.
            </td>
          </tr>
        )}
      </tbody>
    </table>
  )}
</div>

</div>

{deleteDescriptionData && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white p-6 rounded-lg shadow-lg w-96">
      <h2 className="text-xl font-semibold text-gray-700 text-center mb-4">
        هل أنت متأكد أنك تريد حذف هذا الوصف؟
      </h2>
      <div className="flex justify-around mt-4">
        <button
          onClick={() => {
            deleteDescription(
              deleteDescriptionData.descriptionId,
              deleteDescriptionData.mealId
            );
            setDeleteDescriptionData(null); // Close modal after deletion
          }}
          className="bg-red-500 text-white py-2 px-6 rounded-lg hover:bg-red-600"
        >
          نعم
        </button>
        <button
          onClick={() => setDeleteDescriptionData(null)} // Close modal without deletion
          className="bg-gray-500 text-white py-2 px-6 rounded-lg hover:bg-gray-600"
        >
          إلغاء
        </button>
      </div>
    </div>
  </div>
)}



      {deleteIndex !== null && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96">
            <h2 className="text-xl font-semibold text-gray-700 text-center mb-4">
              هل أنت متأكد أنك تريد حذف هذا العنصر؟
            </h2>
            <div className="flex justify-around mt-4">
              <button
                onClick={() => deleteMeal(deleteIndex)}
                className="bg-red-500 text-white py-2 px-6 rounded-lg hover:bg-red-600"
              >
                نعم
              </button>
              <button
                onClick={cancelDelete}
                className="bg-gray-500 text-white py-2 px-6 rounded-lg hover:bg-gray-600"
              >
                إلغاء
              </button>
            </div>
          </div>
        </div>
      )}
</>
  );
};

export default AddFoodType;
